module.exports = __webpack_public_path__ + "static/hariss-9382d4ef684465b47da174a3955c5c22.jpg";